function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgContainerHook(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 30,
    height: 30,
    viewBox: "0 0 32 32",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M16 7v1c0 .576-.462.928-.827 1.055A1 1 0 1 0 16.5 10h1a2 2 0 0 1-1.5 1.937v.836L19.688 16H22a1 1 0 0 1 1 1v7a1 1 0 0 1-1 1H9a1 1 0 0 1-1-1v-7a1 1 0 0 1 1-1h2.312L15 12.773v-.836a2 2 0 0 1-.155-3.827.337.337 0 0 0 .136-.084.089.089 0 0 0 .019-.027V7h1zm-1 .997v.001-.001zm.5 5.667L12.83 16h5.34l-2.67-2.336zM9 17v7h13v-7H9zm3 5v-3h1v3h-1zm3 0v-3h1v3h-1zm3 0v-3h1v3h-1z",
    clipRule: "evenodd",
    style: {
      fill: "#00243d"
    }
  }));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgContainerHook);
export default __webpack_public_path__ + "static/media/container-hook.640a16530eadd2bb4fd722ce2c2f51e7.svg";
export { ForwardRef as ReactComponent };